import { markRepoChargesStatusTo } from "../repoChargesApprove/repoChargesApproval";
// import { UrlConstants } from "../../../../utils/ApiConstants";
// import { authHeader } from "../../../../utils/utils";
import { downloadCall } from "../../../../utils/api";


export const handleExtraActionsOnRecordClick = (data: any, action: any, recordId: any) => {

    if (action.actionName === "Generate RepoRelease Letter") {
      // Handle Settlement Letter Generation
      generateRepoReleaseApprovalLetter(recordId);

    }
  };

  const generateRepoReleaseApprovalLetter = (repoKitNumber: any) => {
    const url = `reposession-waiver/repo-release-approval-letter/generate/${repoKitNumber}`;
    downloadCall('POST', url, `RepoReleaseApproval_${repoKitNumber}.pdf`, null, 'blob');
  };

export const approveOrRejectRepoRelease: any = (recordId: string, data: any, args: any[]) => {
  data["repoKitNo"] = recordId;
  data["status"] = args[1];
  return markRepoChargesStatusTo(recordId, args[0], data, "Successfully " + args[1] + " the  repoKit:" + recordId);
}